import config from 'config'
import * as types from 'constants/action_types'

const defaultState = { byKey: {} }
const reducers = {}

function reduceEmbeddableCards(state, embeddableCards) {
  if (!embeddableCards) return state
  const newByKey = embeddableCards.reduce((reduced, newEmbeddableCard) => {
    const embeddableCard = state.byKey[newEmbeddableCard.key]
    if (newEmbeddableCard.content) {
      // eslint-disable-next-line no-param-reassign
      newEmbeddableCard.content = Object.assign(
        {},
        embeddableCard && embeddableCard.content,
        newEmbeddableCard.content
      )
    }
    if (newEmbeddableCard.isBusy) {
      // eslint-disable-next-line no-param-reassign
      newEmbeddableCard.isBusy = Object.assign(
        {},
        embeddableCard && embeddableCard.isBusy,
        newEmbeddableCard.isBusy
      )
    }
    if (
      (config.embeddable_cards_url.match('redesign') ||
        config.embeddable_cards_url.match('rebirth')) &&
      newEmbeddableCard.endpoint
    ) {
      // eslint-disable-next-line no-param-reassign
      newEmbeddableCard.endpoint = newEmbeddableCard.endpoint.replace(
        'graphql.groovehq.com',
        'graphql-redesign.groovehq.com'
      )
    }
    // eslint-disable-next-line no-param-reassign
    reduced[newEmbeddableCard.key] = Object.assign(
      { isBusy: {} },
      embeddableCard,
      newEmbeddableCard
    )

    return reduced
  }, {})
  return Object.assign({}, state, {
    byKey: Object.assign({}, state.byKey, newByKey),
  })
}

function reduceEmbeddableCard(state, embeddableCard) {
  return reduceEmbeddableCards(state, [embeddableCard])
}

reducers[types.UPDATE_APP_DATA] = (state = defaultState, action) => {
  if (action.data.embeddableCards) {
    return reduceEmbeddableCards(state, action.data.embeddableCards)
  }
  return state
}

reducers[types.FETCH_EMBEDDABLE_CARD_CONTENT_FETCHING] = (
  state = defaultState,
  action
) => {
  const { key, contextCacheKey } = action.data
  return reduceEmbeddableCard(state, {
    key,
    content: {
      [contextCacheKey]: {
        cacheKey: contextCacheKey,
        fetching: true,
      },
    },
  })
}

reducers[types.FETCH_EMBEDDABLE_CARD_CONTENT_RECEIVED] = (
  state = defaultState,
  action
) => {
  const { key, content, contextCacheKey, stillLoading } = action.data

  const wrapper = document.createElement('div')
  wrapper.innerHTML = content
  const scripts = Array.from(wrapper.querySelectorAll('script'))
  scripts.forEach(script => {
    script.remove()
  })

  return reduceEmbeddableCard(state, {
    key,
    isBusy: { global: stillLoading },
    content: {
      [contextCacheKey]: {
        cacheKey: contextCacheKey,
        fetching: false,
        errored: false,
        proxyError: false,
        content,
      },
    },
  })
}

reducers[types.FETCH_EMBEDDABLE_CARD_CONTENT_ERRORED] = (
  state = defaultState,
  action
) => {
  const { key, contextCacheKey, proxyError, errorMessage } = action.data
  return reduceEmbeddableCard(state, {
    key,
    content: {
      [contextCacheKey]: {
        cacheKey: contextCacheKey,
        fetching: false,
        errored: true,
        proxyError,
        lastErrorMessage: errorMessage,
      },
    },
  })
}

reducers[types.UPDATE_CARD_LOADING] = (state = defaultState, action) => {
  const { key, isLoading, cacheKey } = action.data
  return reduceEmbeddableCard(state, {
    key,
    isBusy: { [cacheKey]: isLoading },
  })
}

reducers[types.UPDATE_CARD_COLLAPSED] = (state = defaultState, action) => {
  const { key, isCollapsed, cacheKey } = action.data
  return reduceEmbeddableCard(state, {
    key,
    isCollapsed: { [cacheKey]: isCollapsed },
  })
}

reducers[types.UPDATE_CARD_HIDDEN] = (state = defaultState, action) => {
  const { key, isHidden } = action.data
  return reduceEmbeddableCard(state, {
    key,
    isHidden,
  })
}

reducers[types.TRIGGER_EMBEDDABLE_CARD_ERRORED] = (
  state = defaultState,
  action
) => {
  const { key, contextCacheKey, errorMessage } = action.data
  return reduceEmbeddableCard(state, {
    key,
    content: {
      [contextCacheKey]: {
        cacheKey: contextCacheKey,
        fetching: false,
        errored: true,
        lastErrorMessage: errorMessage,
      },
    },
  })
}

reducers[types.TRIGGER_EMBEDDABLE_CARD_SUCCESS] = (
  state = defaultState,
  action
) => {
  const { key, contextCacheKey } = action.data
  return reduceEmbeddableCard(state, {
    key,
    content: {
      [contextCacheKey]: {
        cacheKey: contextCacheKey,
        fetching: false,
        errored: false,
      },
    },
  })
}

reducers[types.UPDATE_CARD_TAB_TITLE] = (state = defaultState, action) => {
  const { key, title } = action.data
  return reduceEmbeddableCard(state, {
    key,
    tabTitle: title,
  })
}

reducers[types.ACTIVATE_CARD_TAB] = (state = defaultState, action) => {
  const { key } = action.data
  return {
    ...state,
    activeTab: key,
  }
}

reducers[types.CARD_ON_CONTEXT_CHANGE_REGISTERED] = (
  state = defaultState,
  action
) => {
  const { key } = action.data
  return reduceEmbeddableCard(state, {
    key,
    hasOnContextChange: true,
  })
}

export default function reducer(state = defaultState, action) {
  // this is here because a long reducer with many ifs is unreadable
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
